import React from "react";
import { useState } from "react";
import Axios from "axios";
import report from "../img/report.png";
import report1 from "../img/report2.png";
import bg2 from "../img/bg.png";
import img_s from "../img/1727749177056.jpg";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import "../components/style.css";
import "../components/report.css";

import score_individual from "../img/score_individual1.jpg";
import No_image from "../img/No_Image.jpg";
import No_image1 from "../img/No_Image1.jpg";

import Button from "react-bootstrap/Button";
import monitor from "../img/monitor.png";
import exercise from "../img/exercise.png";
import "../fonts/fontReport.css";
import { Container, Row, Col } from "react-bootstrap";
import jwt from "jsonwebtoken";
import "../pages/PageLogin.css";
import Swal from "sweetalert2";
import { checkGroupsUser, getlocalStorage } from "../function/functionALL";
import { BsFillFileEarmarkRichtextFill } from "react-icons/bs";

require("moment/locale/th");

const ModalReport = ({ IdRound, imageUrl }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  // const [imageUrl, setimageUrl] = useState([]);
  const { Token, DataToken_ } = getlocalStorage();
  const role = checkGroupsUser(DataToken_.groups);
  const role_openRole = role?.openRole;
  const navigate = useNavigate();
  const [Datapushup, setDatapushup] = useState([]);
  const [Datarun, setDatarun] = useState([]);
  const [Datasitup, setDatasitup] = useState([]);
  const [Datawalk, setDatawalk] = useState([]);
  const [data, setdata] = useState([]);

  const handleShow = () => {
    Axios.get(process.env.REACT_APP_API_TESTRESULT + `${IdRound}/`, {
      headers: {
        Authorization: "Token " + Token,
      },
    })
      .then((res) => {
        setdata(res.data);
        setDatapushup(res.data.pushup);
        setDatarun(res.data.run);
        setDatasitup(res.data.situp);
        setDatawalk(res.data.walk);
        setShow(true);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          localStorage.removeItem("Token_");
          localStorage.removeItem("Token");
          navigate("/notfound404");
        }
        console.error(err);
        Swal.fire({
          icon: "error",
        });
      });
  };

  const displayQuantity = (Datawalk, Datarun) => {
    const walkQuantity = Datawalk.quantity;
    const runQuantity = Datarun.quantity;

    // กรณีที่ทั้ง walk และ run เท่ากับ -1 หรือ -1.59
    if (
      (walkQuantity === -1 || walkQuantity === "-1:59") &&
      (runQuantity === -1 || runQuantity === "-1:59")
    ) {
      return (
        <div style={{ fontSize: "0.6rem", marginLeft: "15%" }}>ไม่มีคะแนน</div>
      );
    }

    // กรณีที่ walk มีค่า (ไม่เท่ากับ -1 หรือ -1.59)
    if (walkQuantity !== -1 && walkQuantity !== "-1:59") {
      return walkQuantity + " น.";
    }

    // กรณีที่ run มีค่า (ไม่เท่ากับ -1 หรือ -1.59)
    if (runQuantity !== -1 && runQuantity !== "-1:59") {
      return runQuantity + " น.";
    }

    // ค่าเริ่มต้น (กรณีไม่มีอะไรเข้าเงื่อนไขเลย)
    return (
      <div style={{ fontSize: "0.6rem", marginLeft: "15%" }}>ไม่มีคะแนน</div>
    );
  };

  const getValueAfterDash = (text) => {
    // ตรวจสอบว่า text ไม่เป็น undefined หรือ null และมีขีด ("-")
    if (text && text.includes("-")) {
      // แยกค่าและคืนค่าหลังขีด
      return text.split("-")[1];
    } else {
      // ถ้าไม่มีขีดหรือ text เป็น undefined/null คืนค่า null หรือข้อความที่ต้องการ
      return null;
    }
  };

  const fullName = data.tester_fullname || "";
  const nameParts = fullName.split(" ");
  const lastName = nameParts.pop(); // เอาคำสุดท้ายเป็นนามสกุล
  const firstName = nameParts.join(" "); // เอาคำที่เหลือเป็นชื่อ

  return (
    <>
      <div
        style={{
          display: "inline-block",
          color: "#9DA4F1",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          fontSize: "20px",
        }}
        className="btn btn primary"
      >
        <BsFillFileEarmarkRichtextFill onClick={handleShow} />
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
        keyboard={true}
        style={{
          display: "flex", // Center modal content
          alignItems: "center",
          justifyContent: "center",
          height: "100vh", // Full screen height
          width: "100vw", // Full screen width
        }}
      >
        <Modal.Header>
          <p className="m-0 fw-bold" style={{ fontSize: "18px" }}>
            ผลคะแนนการทดสอบ
          </p>
          <button
            type="button"
            className="btn btn-primary custom-close-button"
            style={{ backgroundColor: "rgb(2, 117, 216,0.80)", border: "none" }}
            onClick={handleClose}
          >
            ปิด
          </button>
        </Modal.Header>
        <Modal.Body
          className="p-0 m-0  d-flex align-items-center"
          style={{ height: "65vh", overflow: "hidden" }}
        >
          <div
            className="d-flex"
            style={{
              backgroundImage: `url(${report1})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
              backgroundSize: "contain",
              width: "100%",
              height: "400px",
              overflowY: "auto", // Make content scrollable if it exceeds the modal height

              // overflow: 'hidden',
              position: "relative",
            }}
          >
            <div className="img-profile">
              {imageUrl !== null ? (
                <img
                  src={imageUrl}
                  alt="Profile"
                  style={{
                    width: "auto",
                    height: "122px",
                    overflow: "hidden",
                    position: "static",
                  }}
                />
              ) : (
                <img
                  src={No_image1}
                  alt="Profile"
                  style={{
                    width: "auto",
                    height: "122px",
                    overflow: "hidden",
                    position: "static",
                  }}
                />
              )}
            </div>

            <div className="result-bold kanit-bold">ผลการทดสอบ</div>

            <div className="round-text kanit-bold">
              วงรอบ {getValueAfterDash(data.test_round_text)}
            </div>

            <div className="year-text kolker-brush-regular">
              {data.test_round}
            </div>

            <div className="sit-ups-text saira-stencil-one-regular">
              {Datasitup.quantity === -1 ? (
                <span style={{ fontSize: "10px" }}>ไม่มีคะแนน</span>
              ) : (
                `${Datasitup.quantity} ครั้ง`
              )}
            </div>

            <div className="push-ups-text saira-stencil-one-regular">
              {Datapushup.quantity === -1 ? (
                <span style={{ fontSize: "10px" }}>ไม่มีคะแนน</span>
              ) : (
                `${Datapushup.quantity} ครั้ง`
              )}
            </div>

            <div
              className="run-walk-text saira-stencil-one-regular"
              style={{ width: "20%" }}
            >
              {displayQuantity(Datawalk, Datarun)}
            </div>

            <div
              className="kanit-bold run-walk-textno"
              style={{ fontSize: "7px" }}
            >
              {Datarun.quantity !== "-1:59" && Datarun.quantity !== -1
                ? `ลำดับที่ ${Datarun.run_rank}`
                : ""}
            </div>
            <div className="kanit-thin name-last">{data.tester_fullname}</div>
            {/* <div className="kanit-thin">
                            <span className="name-first">{firstName}</span>
                            <span className="name-last">{lastName}</span>
                        </div> */}

            <div className="tester-affiliation-text kanit-thin">
              สังกัด: {data.work_unit_shortname}
            </div>
          </div>

          {/* <div
                        style={{
                            width: '100%',          // ทำให้กว้างเต็มความกว้างของ Modal.Body
                            height: '100vh',  // ปรับขนาดความสูงให้เหมาะสมกับอุปกรณ
                            minHeight: '200px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            background: `url(${report1}) no-repeat center center`,
                            backgroundSize: 'cover',  // Use 'cover' to fill container
                            color: '#000000',
                            position: 'relative',
                        }}> */}

          {/* </div> */}
          {/* </div> */}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalReport;
